import { render, staticRenderFns } from "./VentasLista.vue?vue&type=template&id=50a3d47e&"
import script from "./VentasLista.vue?vue&type=script&lang=js&"
export * from "./VentasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports